<template>
  <CompanyPage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CompanyPage from '@/components/Company.vue'

export default {
  name: 'Company',
  components: {
    // HelloWorld
    CompanyPage
  }
}
</script>
